<script setup lang="ts">

import InfoCircleIcon from '@/components/icons/InfoCircleIcon.vue'
import { T } from '@tolgee/vue'
import LingoLogo from '@/assets/images/logo.svg'
import { ref } from 'vue'
import LingoGiveawayInfoModal from '@/partners/lingo/lingo-giveaway/components/modals/LingoGiveawayInfoModal.vue'
import { useLocalStorage } from '@vueuse/core'
import { buildDropeeStorageKey } from '@/config/config'
import SoundIcon from '@/components/icons/SoundIcon.vue'
import { useLingoGameSounds } from '@/partners/lingo/lingo-giveaway/composables/sounds'
import SoundMutedIcon from '@/components/icons/SoundMutedIcon.vue'

const closedGiveawayInfoModalFirstTime = useLocalStorage<boolean>(buildDropeeStorageKey('closed_lingo_giveaway_info_modal'), false)
const showGiveawayInfoModal = ref<boolean>(!closedGiveawayInfoModalFirstTime.value)
const { islandSoundStarted, playIslandSound, isLingoGameSoundMuted, toggleSound } = useLingoGameSounds()

function onModalClose() {
  if (!islandSoundStarted.value) {
    playIslandSound()
  }
  showGiveawayInfoModal.value = false
  if (!closedGiveawayInfoModalFirstTime.value) {
    closedGiveawayInfoModalFirstTime.value = true
  }
}
</script>
<template>
  <div class="flex justify-between items-center">
    <div
      class="h-6 w-6 min-w-[24px] text-white"
      @click="toggleSound"
    >
      <SoundMutedIcon
        v-if="isLingoGameSoundMuted"
        class="w-full h-full"
      />
      <SoundIcon
        v-else
        class="w-full h-full"
      />
    </div>
    <div class="flex items-center justify-center gap-x-2.5">
      <img
        :src="LingoLogo"
        class="h-[30px] w-auto"
      >
      <span class="text-light-white text-[24px] leading-[34px] font-semibold">
        <T
          key-name="lingo.giveaway.title"
          default-value="Rewards"
        />
      </span>
    </div>
    <InfoCircleIcon
      class="h-6 w-6 min-w-[24px] text-white/[38%]"
      @click="showGiveawayInfoModal = true"
    />
  </div>
  <LingoGiveawayInfoModal
    :show="showGiveawayInfoModal"
    @hide="onModalClose"
  />
</template>